import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { CustomPdfAppearanceTemplateForm } from "../schemas";
import { customPdfAppearanceTemplateQueryKeys } from "../query-keys";

const savePdfAppearanceTemplate = async (
  slot: number,
  body: CustomPdfAppearanceTemplateForm
) => {
  const { data } = await privateAxios.put<void>(
    `/custom-appearance/pdf-template/${slot}`,
    body
  );
  return data;
};

export const useSavePdfAppearanceTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      slot,
      body,
    }: {
      slot: number;
      body: CustomPdfAppearanceTemplateForm;
    }) => savePdfAppearanceTemplate(slot, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customPdfAppearanceTemplateQueryKeys.all,
      });
    },
  });
};

const deletePdfAppearanceTemplate = async (slot: number) => {
  const { data } = await privateAxios.delete<void>(
    `/custom-appearance/pdf-template/${slot}`
  );
  return data;
};

export const useDeletePdfAppearanceTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ slot }: { slot: number }) =>
      deletePdfAppearanceTemplate(slot),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customPdfAppearanceTemplateQueryKeys.all,
      });
    },
  });
};
